const TAG = {
  BUNDLE: "bundle",
  FINAL_SALE: "Final Sale",
  MYSTERY: "mystery",
  MTO: "MTO",
  CUSTOMIZABLE: "CUSTOMIZABLE",
  SOLID_GOLD: "Components:Solid Gold",
};

export default TAG;
